import React, { useState } from "react";
import { Button, TextField, Autocomplete, Box } from "@mui/material";
import { UseMyPC } from "../../hooks/UseMyPC";
import { UseProduct } from "../product/UseProduct";
import { UseSlaveProduct } from "./UseSlaveProduct";
import { useNavigate, useLocation } from "react-router-dom";
import Detail from "../../main/detail/Detail";
import { rsGotoLast, rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function AddSlaveProduct(props) {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const navigate = useNavigate();
  const location = useLocation();
  const [options2, setOptions2] = useState([]);
  const [options3, setOptions3] = useState([]);
  const { getProductListSlave } = UseProduct();
  const { addSlave } = UseSlaveProduct();
  const { myPc } = UseMyPC();
  const [msGotoLast, setMsGotoLast] = useRecoilState(rsGotoLast);
  const { isSmall } = useBreakpoints();

  var slaveTypes = [
    { relationType: "رنگ", relationTypeID: 1 },
    { relationType: "سایز", relationTypeID: 2 },
    { relationType: "طعم", relationTypeID: 3 },
    { relationType: "تعداد در بسته", relationTypeID: 4 },
    { relationType: "سن مصرف", relationTypeID: 5 },
    { relationType: "جنس محصول", relationTypeID: 6 },
    { relationType: " رایحه", relationTypeID: 7 },
  ];

  const [slave, setSlave] = React.useState({
    relationTypeID: "",
    masterProductID: "",
    slaveProductID: "",
  });

  return (
    <Detail
      breadChilds={{
        title: "محصولات",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/slaveproducts" },
          { name: "افزودن اسلیو", url: "/slaveproducts/addSlaveproduct" },
        ],
      }}
    >
      <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
        <Box gridColumn={isSmall ? "span 12" : "span 6"}>
          <Autocomplete
            disablePortal
            id="combo-box-demo"
            options={options2 ? options2 : ""}
            getOptionLabel={(productList) =>
              productList ? productList.id + " - " + productList.faName : ""
            }
            isOptionEqualToValue={(option, value) =>
              option.value === value.value
            }
            renderInput={(params) => (
              <TextField
                onChange={(search) => {
                  getProductListSlave(myPc, search.target.value, (options) => {
                    setOptions2(options.products);
                  });
                }}
                {...params}
                label="محصول مستر"
              />
            )}
            noOptionsText={" "}
            onChange={(evt, value) => {
              if (value) {
                setSlave({ ...slave, masterProductID: value.id });
              }
            }}
          />
        </Box>
        {!isSmall && <Box gridColumn="span 6"></Box>}
        <Box gridColumn={isSmall ? "span 12" : "span 6"}>
          <Autocomplete
            disablePortal
            id="combo-box-demo"
            options={options3 ? options3 : ""}
            getOptionLabel={(productList) =>
              productList ? productList.id + " - " + productList.faName : ""
            }
            isOptionEqualToValue={(option, value) =>
              option.value === value.value
            }
            renderInput={(params) => (
              <TextField
                onChange={(search) => {
                  getProductListSlave(myPc, search.target.value, (options) => {
                    setOptions3(options.products);
                  });
                }}
                {...params}
                label="محصول اسلیو"
              />
            )}
            noOptionsText={" "}
            onChange={(evt, value) => {
              if (value) {
                setSlave({ ...slave, slaveProductID: value.id });
              }
            }}
          />
        </Box>
        {!isSmall && <Box gridColumn="span 6"></Box>}
        <Box gridColumn={isSmall ? "span 12" : "span 3"}>
          <Autocomplete
            disablePortal
            id="combo-box-demo"
            options={slaveTypes}
            getOptionLabel={(slaveTypes) => slaveTypes.relationType}
            isOptionEqualToValue={(option, value) =>
              option.value === value.value
            }
            renderInput={(params) => (
              <TextField {...params} label="نوع ارتباط" />
            )}
            onChange={(evt, value) => {
              if (value) {
                setSlave({
                  ...slave,
                  relationTypeID: value.relationTypeID,
                });
              }
            }}
          />
        </Box>
        <Box gridColumn="span 9"></Box>
        <Box
          sx={{ display: "flex", justifyContent: "flex-end" }}
          gridColumn={isSmall ? "span 12" : "span 6"}
        >
          <Button
            sx={{ mr: 2, width: "80px" }}
            variant="contained"
            color="secondary"
            onClick={() => {
              setProgress(true);
              addSlave(slave, () => {
                setMsGotoLast(true);
                navigate("/slaveproducts", {
                  state: { ...location.state, isBack: true },
                  replace: true,
                });
              });
            }}
          >
            ایجاد
          </Button>
          <Button
            sx={{ width: "80px" }}
            variant="outlined"
            color="secondary"
            onClick={() => {
              navigate("/slaveproducts", {
                state: { ...location.state, isBack: true },
                replace: true,
              });
            }}
          >
            بازگشت
          </Button>
        </Box>
      </Box>
    </Detail>
  );
}
